import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// LanguageDetector removed - forcing Spanish language

// Import translation files
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
};

i18n
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    resources,
    lng: 'es', // Force Spanish language
    fallbackLng: 'es', // Default language (Spanish for LATAM)
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n;